import styled from '@emotion/styled';
import { ReactElement } from 'react';

import { Theme } from '../../../../theme/interface/detailed';
import { useTheme } from '../../../../theme/useTheme';
import { Interface } from '../interface';

export const AudioIcon = styled((props: Interface): ReactElement => {
	const theme = useTheme();

	return (
		<div {...props}>
			<svg
				width={theme.videoCalls.icons.microphoneIcon.width}
				height={theme.videoCalls.icons.microphoneIcon.height}
				viewBox="0 0 25 25"
				fill={theme.videoCalls.icons.microphoneIcon.backgroundColor}
				xmlns="http://www.w3.org/2000/svg"
			>
				<g clipPath="url(#clip0)" fill={theme.videoCalls.icons.microphoneIcon.fill}>
					<path d="M7.944 5.674v6.17a4.803 4.803 0 004.797 4.798 4.803 4.803 0 004.797-4.797v-6.17A4.802 4.802 0 0012.741.876a4.802 4.802 0 00-4.797 4.797zm7.936 0v6.17a3.141 3.141 0 01-3.139 3.139 3.141 3.141 0 01-3.138-3.138v-6.17a3.141 3.141 0 013.138-3.14 3.141 3.141 0 013.139 3.14z" />
					<path d="M19.884 11.018a.83.83 0 00-.832.827 6.324 6.324 0 01-6.315 6.315 6.324 6.324 0 01-6.316-6.315.828.828 0 00-.832-.827.83.83 0 00-.831.827c0 4.115 3.133 7.514 7.142 7.93v3.148H9.13a.832.832 0 00-.833.832c0 .46.373.827.832.827h7.2a.83.83 0 00.832-.827.832.832 0 00-.832-.832h-2.77v-3.148c4.008-.416 7.142-3.815 7.142-7.93a.81.81 0 00-.817-.827z" />
				</g>
				<defs>
					<clipPath id="clip0">
						<path
							fill={theme.videoCalls.icons.microphoneIcon.fill}
							transform="translate(.877 .877)"
							d="M0 0h23.705v23.705H0z"
						/>
					</clipPath>
				</defs>
			</svg>
		</div>
	);
})(({ theme }: { theme?: Theme }) => theme?.videoCalls.icons.microphoneIcon);
